module.exports = __webpack_public_path__ + "img/NB-loT.749683e8.jpg";